import * as yup from "yup";

export const listingTypes = [
  {
    label: "Short-Term Rental",
    value: "short-term rental",
    key: 1,
  },
  {
    label: "Adventure",
    value: "adventure",
    key: 2,
    disabled: true,
  },
  {
    label: "Event",
    value: "event",
    key: 3,
    disabled: true,
  },
  {
    label: "Hotel",
    value: "hotel",
    key: 4,
    disabled: true,
  },
  {
    label: "Restaurant",
    value: "restaurant",
    key: 5,
    disabled: true,
  },
  {
    label: "Shop",
    value: "shop",
    key: 6,
    disabled: true,
  },
];

export const spaceTypes = [
  {
    label: "Entire Place",
    value: "Entire Place",
    key: 1,
  },
  {
    label: "Private Room",
    value: "Private Room",
    key: 2,
  },
  {
    label: "Shared Room",
    value: "Shared Room",
    key: 3,
  },
];

export const lodgingType = [
  {
    label: "Apt./Condo/Loft",
    value: "Apt. / Condo / Loft",
    key: 1,
  },
  {
    label: "Bed & Breakfast",
    value: "Bed & Breakfast",
    key: 2,
  },
  {
    label: "Cabin",
    value: "Cabin",
    key: 3,
  },
  {
    label: "Campsite",
    value: "Campsite",
    key: 4,
  },
  {
    label: "Farm",
    value: "Farm",
    key: 5,
  },
  {
    label: "Hangar",
    value: "Hangar",
    key: 6,
  },
  {
    label: "Hangar Home",
    value: "Hangar Home",
    key: 7,
  },
  {
    label: "House",
    value: "House",
    key: 8,
  },
  {
    label: "Hotel Room",
    value: "Hotel Room",
    key: 9,
  },
  {
    label: "Mansion",
    value: "Mansion",
    key: 10,
  },
  {
    label: "Novelty",
    value: "Novelty",
    key: 11,
  },
  {
    label: "RV",
    value: "RV",
    key: 12,
  },
  {
    label: "RV Pad",
    value: "RV Pad",
    key: 13,
  },
  {
    label: "Tiny Home",
    value: "tiny home",
    key: 14,
  },
];

export const unitMeasure = [
  {
    label: "Sq ft",
    value: "ft",
    key: 1,
  },
  {
    label: "Sq m",
    value: "m",
    key: 2,
  },
  {
    label: "Acre",
    value: "acre",
    key: 2,
  },
];

export const airportUse = [
  {
    label: "Public",
    value: "Public",
    key: 1,
  },
  {
    label: "Private",
    value: "Private",
    key: 2,
  },
  {
    label: "Private - permission required to land",
    value: "Private - permission required to land",
    key: 3,
  },
];

export const lighting = [
  {
    label: "Yes",
    value: 1,
    key: 1,
  },
  {
    label: "No",
    value: 0,
    key: 2,
  },
];

export const fuelOptions = [
  { value: "no", label: "None" },
  { value: "100LL", label: "100LL" },
  { value: "Jet-A", label: "Jet-A" },
  { value: "Jet-A1", label: "Jet-A1" },
  { value: "Jet-A+", label: "Jet-A+" },
  { value: "Jet-B", label: "Jet-B" },
  { value: "MoGas", label: "MoGas" },
  { value: "UL94", label: "UL94" },
  { value: "other", label: "Other" },
];

export const hangarOptions = [
  {
    label: "Hangar",
    value: "Hangar",
    key: 1,
  },
  {
    label: "Hangar and Tie-downs",
    value: "Hangar and Tie-downs",
    key: 2,
  },
  {
    label: "Tie-downs",
    value: "Tie-downs",
    key: 3,
  },
  {
    label: "Bring your own tie-downs",
    value: "Bring your own tie-downs",
    key: 4,
  },
  {
    label: " Mooring at the house",
    value: " Mooring at the house",
    key: 5,
  },
];

export const colorOptions = [
  { value: "Asphalt", label: "Asphalt" },
  { value: "Concrete", label: "Concrete" },
  { value: "Grass", label: "Grass" },
  { value: "Gravel", label: "Gravel" },
  { value: "Ice", label: "Ice" },
  { value: "Sand", label: "Sand" },
  { value: "Snow", label: "Snow" },
  { value: "Water", label: "Water" },
  { value: "Turf", label: "Turf" },
  { value: "Other", label: "Other" },
];

export const patternOptions = [
  {
    label: "Left, Left",
    value: "left, left",
    key: 1,
  },
  {
    label: "Left, Right",
    value: "left, right",
    key: 2,
  },
  {
    label: "Right, Left",
    value: "right, left",
    key: 3,
  },
  {
    label: "Right, Right",
    value: "right, right",
    key: 4,
  },
];

export const distanceOptions = [
  {
    label: "0 Miles",
    value: "0",
    key: 1,
  },
  {
    label: "0 to 1 Miles",
    value: "1",
    key: 2,
  },
  {
    label: "1.1 to 3 Miles",
    value: "3",
    key: 3,
  },
  {
    label: "3.1 to 7 Miles",
    value: "7",
    key: 4,
  },
  {
    label: "7+ Miles",
    value: "8",
    key: 5,
  },
];

export const groundTransportationOptions = [
  {
    label: "We have a courtesy vehicle waiting for you!",
    value: "We have a courtesy vehicle waiting for you!",
    key: 1,
  },
  {
    label: "We have a vehicle you can rent from us!",
    value: "We have a vehicle you can rent from us!",
    key: 2,
  },
  {
    label: "Rent a vehicle right in the airport! Their phone number is:",
    value: "Rent a vehicle right in the airport! Their phone number is:",
    key: 3,
  },
  {
    label: "We will give you a ride to the nearest rental vehicle agency!",
    value: "We will give you a ride to the nearest rental vehicle agency!",
    key: 4,
  },
  {
    label:
      "We have a deal with the FBO so you can keep the vehicle your whole stay!",
    value:
      "We have a deal with the FBO so you can keep the vehicle your whole stay!",
    key: 5,
  },
  {
    label: "You don't need a vehicle here!",
    value: "You don't need a vehicle here!",
    key: 6,
  },
];

export const timesOptions = [
  "06:00 AM",
  "06:30 AM",
  "07:00 AM",
  "07:30 AM",
  "08:00 AM",
  "08:30 AM",
  "09:00 AM",
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
  "05:30 PM",
  "06:00 PM",
  "06:30 PM",
  "07:00 PM",
  "07:30 PM",
  "08:00 PM",
  "08:30 PM",
  "09:00 PM",
];

export const rules = [
  {
    value:
      "<p class='mb-0'>Quiet Hours: Quiet hours are from [specific time] to [specific time]. Please respect the neighbors.</p>",
    label:
      "Quiet Hours: Quiet hours are from [specific time] to [specific time]. Please respect the neighbors.",
    id: 1,
  },
  {
    value:
      "<p class='mb-0'>Respect the Neighborhood: Please be mindful of noise and parking, and respect the property and surrounding community.</p>",
    label:
      "Respect the Neighborhood: Please be mindful of noise and parking, and respect the property and surrounding community.",
    id: 2,
  },
  {
    value:
      "<p class='mb-0'>Report Any Damages: Please report any accidental damages immediately. Any unreported damages may result in fees.</p>",
    label:
      "Report Any Damages: Please report any accidental damages immediately. Any unreported damages may result in fees.",
    id: 3,
  },
  {
    value:
      "<p class='mb-0'>No Unregistered Guests: Only registered guests listed in the booking are allowed to stay at the property. No additional overnight guests.</p>",
    label:
      "No Unregistered Guests: Only registered guests listed in the booking are allowed to stay at the property. No additional overnight guests.",
    id: 4,
  },
  {
    value:
      "<p class='mb-0'>Use of Amenities: Please use all amenities (pool, hot tub, etc.) responsibly. Follow safety rules, and use at your own risk.</p>",
    label:
      "Use of Amenities: Please use all amenities (pool, hot tub, etc.) responsibly. Follow safety rules, and use at your own risk.",
    id: 5,
  },
  {
    value:
      "<p class='mb-0'>Cleaning: Please tidy up before checkout. Washing dishes and taking out the trash would be appreciated.</p>",
    label:
      "Cleaning: Please tidy up before checkout. Washing dishes and taking out the trash would be appreciated.",
    id: 6,
  },
  {
    value:
      "<p class='mb-0'>Key/Entry Instructions: Guests are responsible for keeping the keys and access codes safe. A fee may apply for lost keys or access codes.</p>",
    label:
      "Key/Entry Instructions: Guests are responsible for keeping the keys and access codes safe. A fee may apply for lost keys or access codes.",
    id: 7,
  },
  {
    value:
      "<p class='mb-0'>Trash and Recycling: Guests are required to follow the trash and recycling procedures. Please dispose of garbage properly.</p>",
    label:
      "Trash and Recycling: Guests are required to follow the trash and recycling procedures. Please dispose of garbage properly.",
    id: 8,
  },
  {
    value:
      "<p class='mb-0'>Energy Conservation: Please turn off lights, AC/heating, and appliances when not in use.</p>",
    label:
      "Energy Conservation: Please turn off lights, AC/heating, and appliances when not in use.",
    id: 9,
  },
  {
    value:
      "<p class='mb-0'>Parking: Parking is limited to [insert number] spaces. Guests are responsible for following the parking rules.</p>",
    label:
      "Parking: Parking is limited to [insert number] spaces. Guests are responsible for following the parking rules.",
    id: 10,
  },
  {
    value:
      "<p class='mb-0'>Children: Children are welcome, but supervision is required, especially around [mention any safety concerns like pools or balconies].</p>",
    label:
      "Children: Children are welcome, but supervision is required, especially around [mention any safety concerns like pools or balconies].",
    id: 11,
  },
  {
    value:
      "<p class='mb-0'>Security Cameras: For your safety and security, there are [exterior] cameras monitoring the property.</p>",
    label:
      "Security Cameras: For your safety and security, there are [exterior] cameras monitoring the property.",
    id: 12,
  },
  {
    value:
      "<p class='mb-0'>House Access: Guests should only access the areas of the home specified in the listing. Certain parts of the property may be off-limits.</p>",
    label:
      "House Access: Guests should only access the areas of the home specified in the listing. Certain parts of the property may be off-limits.",
    id: 13,
  },
  {
    value:
      "<p class='mb-0'>Local Laws: Please adhere to all local laws and regulations during your stay.</p>",
    label:
      "Local Laws: Please adhere to all local laws and regulations during your stay.",
    id: 14,
  },
];

export const welcomeMessageList = [
  {
    key: "1",
    value:
      "<p class='mb-0'>We’re delighted to have you stay with us! To make your arrival seamless, here’s everything you need to know:</p>",
    label:
      "We’re delighted to have you stay with us! To make your arrival seamless, here’s everything you need to know:",
  },
  {
    key: "2",
    value: "<p class='mb-0'>1. Check-in Instructions:</p>",
    label: "1. Check-in Instructions:",
  },
  {
    key: "3",
    value:
      "<p class='mb-0'>Address: [Insert full address with any special notes, like landmarks].</p>",
    label:
      "Address: [Insert full address with any special notes, like landmarks].",
  },
  {
    key: "4",
    value:
      "<p class='mb-0'>Entry Code: Use [insert code] at the front door keypad to unlock. Ensure you press [insert instructions] after entering the code.</p>",
    label:
      "Entry Code: Use [insert code] at the front door keypad to unlock. Ensure you press [insert instructions] after entering the code.",
  },
  {
    key: "5",
    value: "<p class='mb-0'>Check-in Time: [Insert time, e.g., 3:00 PM].</p>",
    label: "Check-in Time: [Insert time, e.g., 3:00 PM].",
  },
  {
    key: "6",
    value:
      "<p class='mb-0'>Parking: [Provide parking details, such as designated spots or street parking tips].</p>",
    label:
      "Parking: [Provide parking details, such as designated spots or street parking tips].",
  },
  {
    key: "7",
    value: "<p class='mb-0'>2. Wi-Fi Information:</p>",
    label: "2. Wi-Fi Information:",
  },
  {
    key: "8",
    value: "<p class='mb-0'>Network Name: [Insert Wi-Fi name].</p>",
    label: "Network Name: [Insert Wi-Fi name].",
  },
  {
    key: "9",
    value: "<p class='mb-0'>Password: [Insert password].</p>",
    label: "Password: [Insert password].",
  },
  {
    key: "10",
    value: "<p class='mb-0'>3. Appliance Use:</p>",
    label: "3. Appliance Use:",
  },
  {
    key: "11",
    value:
      "<p class='mb-0'>Thermostat: [Explain how to use it and preferred temperature settings].</p>",
    label:
      "Thermostat: [Explain how to use it and preferred temperature settings].",
  },
  {
    key: "12",
    value:
      "<p class='mb-0'>Kitchen Appliances: Feel free to use all appliances. Please ensure the oven and stovetop are turned off after use.</p>",
    label:
      "Kitchen Appliances: Feel free to use all appliances. Please ensure the oven and stovetop are turned off after use.",
  },
  {
    key: "13",
    value:
      "<p class='mb-0'>Washer/Dryer: [Insert operating instructions if available for use].</p>",
    label:
      "Washer/Dryer: [Insert operating instructions if available for use].",
  },
  {
    key: "14",
    value: "<p class='mb-0'>4. Emergency Contacts:</p>",
    label: "4. Emergency Contacts:",
  },
  {
    key: "15",
    value:
      "<p class='mb-0'>Host Contact: [Insert phone number or message option].</p>",
    label: "Host Contact: [Insert phone number or message option].",
  },
  {
    key: "16",
    value:
      "<p class='mb-0'>Local Emergency Services: Dial [insert number, e.g., 911].</p>",
    label: "Local Emergency Services: Dial [insert number, e.g., 911].",
  },
  {
    key: "17",
    value:
      "<p class='mb-0'>Nearest Hospital/Clinic: [Insert address and contact].</p>",
    label: "Nearest Hospital/Clinic: [Insert address and contact].",
  },
  {
    key: "18",
    value: "<p class='mb-0'>5. Check-Out Instructions:</p>",
    label: "5. Check-Out Instructions:",
  },
  {
    key: "19",
    value: "<p class='mb-0'>Check-Out Time: [Insert time, e.g., 11:00 AM].</p>",
    label: "Check-Out Time: [Insert time, e.g., 11:00 AM].",
  },
  {
    key: "20",
    value:
      "<p class='mb-0'>Cleaning Up: Please leave used towels in the bathroom and ensure all dishes are washed or placed in the dishwasher.</p>",
    label:
      "Cleaning Up: Please leave used towels in the bathroom and ensure all dishes are washed or placed in the dishwasher.",
  },
  {
    key: "21",
    value:
      "<p class='mb-0'>Trash: [Insert instructions for trash disposal, e.g., place bags in the outdoor bin].</p>",
    label:
      "Trash: [Insert instructions for trash disposal, e.g., place bags in the outdoor bin].",
  },
  {
    key: "22",
    value:
      "<p class='mb-0'>Keys: [Insert details if a key is used, e.g., leave it in the lockbox or on the counter].</p>",
    label:
      "Keys: [Insert details if a key is used, e.g., leave it in the lockbox or on the counter].",
  },
  {
    key: "23",
    value: "<p class='mb-0'>6. Local Recommendations:</p>",
    label: "6. Local Recommendations:",
  },
  {
    key: "24",
    value:
      "<p class='mb-0'>Grocery Stores: [Insert name and distance of the nearest store].</p>",
    label: "Grocery Stores: [Insert name and distance of the nearest store].",
  },
  {
    key: "25",
    value:
      "<p class='mb-0'>Restaurants: Check out [insert 2-3 restaurant suggestions].</p>",
    label: "Restaurants: Check out [insert 2-3 restaurant suggestions].",
  },
  {
    key: "26",
    value:
      "<p class='mb-0'>Activities: We recommend [insert local attractions].</p>",
    label: "Activities: We recommend [insert local attractions].",
  },
  {
    key: "27",
    value: "<p class='mb-0'>7. Additional Notes:</p>",
    label: "7. Additional Notes:",
  },
  {
    key: "28",
    value:
      "<p class='mb-0'>Welcome Basket: Enjoy a small welcome basket with [insert items, e.g., snacks, water bottles].</p>",
    label:
      "Welcome Basket: Enjoy a small welcome basket with [insert items, e.g., snacks, water bottles].",
  },
  {
    key: "29",
    value:
      "<p class='mb-0'>Guidebook: There’s a digital or physical guidebook provided with more detailed instructions and recommendations.</p>",
    label:
      "Guidebook: There’s a digital or physical guidebook provided with more detailed instructions and recommendations.",
  },
  {
    key: "30",
    value:
      "<p class='mb-0'>Respect Our Neighbors: Please be considerate of our community.</p>",
    label: "Respect Our Neighbors: Please be considerate of our community.",
  },
  {
    key: "31",
    value:
      "<p class='mb-0'>Thank you for choosing to stay with us! We hope you have a fantastic visit. Feel free to reach out with any questions or concerns.</p>",
    label:
      "Thank you for choosing to stay with us! We hope you have a fantastic visit. Feel free to reach out with any questions or concerns.",
  },
];

export const listingFilterTypes = [
  { id: 1, label: "All", value: "all" },
  { id: 3, label: "Published", value: "published" },
  { id: 5, label: "Pending", value: "pending" },
  { id: 6, label: "Deactivated", value: "disable" },
];

export const bookingsFilterType = [
  { id: 1, label: "All", value: "all" },
  {
    id: 2,
    label: "Mine",
    value: "mine",
  },
  {
    id: 3,
    label: "Others",
    value: "others",
  },
];

export const addListingValidationSchema = yup.object().shape({
  listing_type: yup.string().required("Listing type is required."),

  // Location fields
  address: yup.string().required("Address is required."),
  unit_no: yup.string().notRequired().nullable(),
  city: yup.string().required("City is required."),
  state: yup.string().required("State is required."),
  zipcode: yup.string().required("ZIP / Postal Code is required."),
  area: yup.string().notRequired().nullable(),
  country: yup.string().required("Country is required."),
  longitude: yup.string().required("Longitude is required."),
  latitude: yup.string().required("Latitude is required."),

  // Media Section
  images: yup
    .array()
    .of(yup.mixed().required("Image is required."))
    .min(1, "At least one image is required."),

  // Information section
  type_of_space: yup.string().required("Type of space is required."),
  lodging_type: yup.string().required("Lodging type is required."),
  title: yup.string().required("Title is required."),
  no_of_guest: yup
    .string()
    .required("Number of guest is required.")
    .test("less-than-27", "Value cannot be greater than 26", function (value) {
      return +value < 27;
    }),
  no_of_bedrooms: yup.string().required("Number of bedroom is required."),
  no_of_beds: yup.string().required("Number of bed is required."),
  no_of_bathrooms: yup
    .string()
    .required("Number of bathrooms is required.")
    .matches(
      /^(?:[0-9]|[1-9][0-9])(?:\.5|\.75)?$/,
      "Number of bathrooms must be a whole number or a decimal ending in .5 or .75, between 0 and 99 (e.g., 1.5, 1.75, 2.5, etc.)."
    )
    .test(
      "max",
      "Number of bathrooms must be between 0 and 99.",
      (value) => !value || (parseFloat(value) >= 0 && parseFloat(value) <= 99)
    ),
  no_of_rooms: yup.string().required("Number of room is required."),
  unit_of_measure: yup.string().required("Unit of measure is required."),
  size: yup.string().required("Size is required."),
  description: yup.string().required("Description is required."),

  // Bedrooms section
  bedrooms: yup.array().of(
    yup.object().shape({
      name: yup.string().required("Bedroom name is required."),
      no_of_guest: yup
        .string()
        .required("Number of guest bedroom is required."),
      no_of_bed: yup.string().required("Number of beds is required."),
      bed_type: yup.string().required("Bed type is required."),
    })
  ),

  // Airports section
  airports: yup.array().of(
    yup.object().shape({
      airport_identifier: yup.string().required("Identifier is required."),
      airport_name: yup.string().required("Airport name is required."),
      airport_use: yup.string().required("Airport use is required."),
      operation_hours: yup.string().required("Operation hour is required."),
      lighting: yup
        .number()
        .oneOf([0, 1], "Invalid value for lighting")
        .required("This field is required."),
      ctaf_unicom: yup.string().required("CTAF/UNICOM is required."),
      fuel: yup
        .array()
        .of(yup.string().required("Fuel must be a string."))
        .min(1, "At least one option is required."),
      surface: yup
        .array()
        .of(yup.string().required("Surface must be a string."))
        .min(1, "At least one option is required."),
      parking: yup.string().required("Parking is required."),
      orientation: yup
        .string()
        .matches(/^\d{2}\/\d{2}$/, "Orientation must be in the format XX/XX")
        .notRequired()
        .nullable(),
      runway_condition: yup.string().notRequired().nullable(),
      pattern: yup.string().required("Pattern is required."),
      distance_from_runway: yup
        .string()
        .required("Distance from runway is required."),
      air_nav: yup.string().notRequired().nullable(),
      ground_transportation: yup
        .string()
        .required("Ground transportation is required."),

      additional_info: yup.string().notRequired().nullable(),

      dimension_feetX: yup.string().required("This field is required."),
      dimension_feetY: yup.string().required("This field is required."),
      dimension_metersX: yup.string().required("This field is required."),
      dimension_metersY: yup.string().required("This field is required."),

      elevation_feets: yup.string().required("Airport Elevation is required."),

      elevation_meters: yup.string().required("Airport Elevation is required."),
    })
  ),
  instant_booking: yup
    .number()
    .oneOf([0, 1], "Invalid value for instant booking")
    .required("This field is required."),
  nightly_price: yup.string().required("Nightly price is required."),
  apply_weekend_price: yup
    .string()
    .nullable()
    .test(
      "apply-weekend-price-required",
      "Apply weekend price is required if weekend nightly price is set",
      function (value) {
        const { weekend_nightly_price } = this.parent;
        if (weekend_nightly_price && !value) {
          return false;
        }
        return true;
      }
    ),

  weekend_nightly_price: yup.string().nullable().notRequired(),

  nightly_price_seven_plus: yup.string().notRequired().nullable(),
  nightly_price_thirty_plus: yup.string().notRequired().nullable(),

  additional_guest: yup
    .number()
    .oneOf([0, 1], "Invalid value for additional guest")
    .required("This field is required."),

  no_of_additional_guest: yup
    .string()
    .when("additional_guest", (additional_guest, schema) => {
      return additional_guest === 1
        ? schema.required(
            'Number of additional guests is required when "Additional Guest" is selected.'
          )
        : schema.nullable().notRequired();
    }),

  additional_guest_price: yup
    .string()
    .when("additional_guest", (additional_guest, schema) => {
      return additional_guest === 1
        ? schema.required(
            'Additional guest price is required when "Additional Guest" is selected.'
          )
        : schema.nullable().notRequired();
    }),

  pet_allowed: yup
    .number()
    .oneOf([0, 1], "Invalid value for pets allowed")
    .required("This field is required."),

  no_of_pets: yup.string().when("pet_allowed", (pet_allowed, schema) => {
    return pet_allowed === 1
      ? schema.required("Number of pets is required when pets are allowed.")
      : schema.nullable().notRequired();
  }),

  price_per_pet: yup.string().when("pet_allowed", (pet_allowed, schema) => {
    return pet_allowed === 1
      ? schema.required("Price per pet is required when pets are allowed.")
      : schema.nullable().notRequired();
  }),

  cleaning_fee: yup.string().notRequired().nullable(),
  cleaning_freq: yup.string().notRequired().nullable(),

  city_fee: yup.string().notRequired().nullable(),
  city_fee_freq: yup.string().notRequired().nullable(),
  tax_percentage: yup.string().required("Tax is required."),

  custom_period_pricing: yup
    .number()
    .oneOf([0, 1], "Invalid value for custom period pricing")
    .required("This field is required."),

  custom_periods: yup.array().when("custom_period_pricing", {
    is: 1,
    then: () =>
      yup
        .array()
        .of(
          yup.object().shape({
            start_date: yup
              .date()
              .nullable()
              .required("Start date is required."),
            end_date: yup.date().nullable().required("End date is required."),
            nightly_price: yup.string().required("Custom price is required."),
            // weekend_price: yup
            //   .string()
            //   .required("Custom weekly price is required."),
            price_add_guest: yup
              .string()
              .required("Price per additional guest is required."),
          })
        )
        .min(1, "At least one custom period is required."),
    otherwise: () => yup.array().notRequired(),
  }),

  extra_services: yup
    .number()
    .oneOf([0, 1], "Invalid value for extra services")
    .required("This field is required."),
  extra_service: yup.array().when("extra_services", {
    is: 1,
    then: () =>
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required("Service name is required."),
            price: yup.string().required("Service price is required."),
            type: yup.string().required("Service type is required."),
            quantity: yup.string().required("Quantity is required."),
          })
        )
        .min(1, "At least one extra service is required."),
    otherwise: () => yup.array().notRequired(),
  }),

  features: yup.array().of(
    yup.object().shape({
      id: yup.string().required("Feature is required."),
      sub_features: yup.array().when("id", {
        is: (id) => !!id,
        then: () =>
          yup
            .array()
            .of(yup.string().required("Sub-feature is required"))
            .min(1, "At least one sub-feature is required"),
        otherwise: () => yup.array().notRequired(),
      }),
    })
  ),

  cancellation_policy_short: yup
    .string()
    .required("Short cancellation policy is required."),

  cancellation_policy_long: yup.string().when("max_day_booking", {
    is: (max_day_booking) => max_day_booking >= 28,
    then: () => yup.string().required("Long cancellation policy is required."),
    otherwise: () => yup.string().notRequired(),
  }),

  min_day_booking: yup
    .string()
    .required("minimum days of booking policy is required."),
  max_day_booking: yup
    .string()
    .required("maximum days of booking policy is required."),
  check_in_after: yup.string().required("Time is required."),
  check_out_before: yup.string().required("Time is required."),
  smoking_rules: yup.string().when("smoking_allowed", {
    is: (val) => val === 1,
    then: () => yup.string().required("Smoking rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  pet_rules: yup.string().when("rules_pet_allowed", {
    is: (val) => val === 1,
    then: () => yup.string().required("Pet rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  party_rules: yup.string().when("party_allowed", {
    is: (val) => val === 1,
    then: () => yup.string().required("Party rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  children_rules: yup.string().when("children_allowed", {
    is: (val) => val === 1,
    then: () => yup.string().required("Children rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  rules: yup.string().required("Rules is required."),
  welcome_message: yup.string().required("Welcome message is required."),
});

export const addListingDraftValidationSchema = yup.object().shape({
  listing_type: yup.string().required("Listing type is required."),

  // Information section
  address: yup.string().notRequired().nullable(),
  unit_no: yup.string().notRequired().nullable(),
  city: yup.string().notRequired().nullable(),
  state: yup.string().notRequired().nullable(),
  zipcode: yup.string().notRequired().nullable(),
  area: yup.string().notRequired().nullable(),
  country: yup.string().notRequired().nullable(),
  longitude: yup.string().notRequired().nullable(),
  latitude: yup.string().notRequired().nullable(),

  // Media Section
  images: yup.array().notRequired(),

  // Information section
  type_of_space: yup.string().notRequired().nullable(),
  lodging_type: yup.string().notRequired().nullable(),
  title: yup.string().notRequired().nullable(),
  no_of_guest: yup
    .string()
    .nullable() // Allows null or empty value
    .notRequired() // Field is optional
    .test("less-than-17", "Value cannot be greater than 16", function (value) {
      if (value === null || value === undefined || value === "") return true; // Skip validation if value is empty
      return +value < 17; // Validate if value is present
    }),
  no_of_bedrooms: yup.string().notRequired().nullable(),
  no_of_beds: yup.string().notRequired().nullable(),
  no_of_bathrooms: yup.string().notRequired().nullable(),
  no_of_rooms: yup.string().notRequired().nullable(),
  unit_of_measure: yup.string().notRequired().nullable(),
  size: yup.string().notRequired().nullable(),
  description: yup.string().notRequired().nullable(),

  // Bedrooms section
  bedrooms: yup.array().of(
    yup.object().shape({
      name: yup.string().notRequired().nullable(),
      no_of_guest: yup.string().notRequired().nullable(),
      no_of_bed: yup.string().notRequired().nullable(),
      bed_type: yup.string().notRequired().nullable(),
    })
  ),

  // Airports section
  airports: yup.array().of(
    yup.object().shape({
      airport_identifier: yup
        .string()
        .nullable() // Allows null or empty value
        .notRequired(), // Field is optional
      airport_name: yup.string().notRequired().nullable(),
      airport_use: yup.string().notRequired().nullable(),
      operation_hours: yup.string().notRequired().nullable(),
      lighting: yup
        .number()
        .oneOf([0, 1], "Invalid value for lighting")
        .notRequired(),
      ctaf_unicom: yup.string().notRequired().nullable(),
      fuel: yup
        .array()
        .of(yup.string().required("Fuel must be a string."))
        .notRequired() // Field is optional
        .nullable() // Allows null value
        .ensure(), // Ensures it is always treated as an array (even if undefined or null)
      surface: yup
        .array()
        .of(yup.string().required("Surface must be a string."))
        .notRequired() // Field is optional
        .nullable() // Allows null value
        .ensure(), // Ensures it is always treated as an array (even if undefined or null)
      parking: yup.string().notRequired().nullable(),
      orientation: yup.string().notRequired().nullable(),
      runway_condition: yup.string().notRequired().nullable(),
      pattern: yup.string().notRequired().nullable(),
      distance_from_runway: yup.string().notRequired().nullable(),
      air_nav: yup.string().notRequired().nullable(),
      ground_transportation: yup.string().notRequired().nullable(),

      additional_info: yup.string().notRequired().nullable(),

      dimension_feetX: yup.string().notRequired().nullable(),
      dimension_feetY: yup.string().notRequired().nullable(),
      dimension_metersX: yup.string().notRequired().nullable(),
      dimension_metersY: yup.string().notRequired().nullable(),

      elevation_feets: yup.string().notRequired().nullable(),

      elevation_meters: yup.string().notRequired().nullable(),
    })
  ),
  instant_booking: yup
    .number()
    .oneOf([0, 1], "Invalid value for instant booking")
    .notRequired(),
  nightly_price: yup.string().notRequired().nullable(),
  apply_weekend_price: yup.string().nullable().notRequired(),
  weekend_nightly_price: yup.string().nullable().notRequired(),

  nightly_price_seven_plus: yup.string().nullable().notRequired(),
  nightly_price_thirty_plus: yup.string().nullable().notRequired(),

  additional_guest: yup
    .number()
    .oneOf([0, 1], "Invalid value for additional guest")
    .notRequired(),

  no_of_additional_guest: yup
    .string()
    .when("additional_guest", (additional_guest, schema) => {
      return additional_guest === 1
        ? schema.required(
            'Number of additional guests is required when "Additional Guest" is selected.'
          )
        : schema;
    }),

  additional_guest_price: yup
    .string()
    .when("additional_guest", (additional_guest, schema) => {
      return additional_guest === 1
        ? schema.required(
            'Additional guest price is required when "Additional Guest" is selected.'
          )
        : schema;
    }),

  pet_allowed: yup
    .number()
    .oneOf([0, 1], "Invalid value for pets allowed")
    .notRequired(),

  no_of_pets: yup.string().when("pet_allowed", (pet_allowed, schema) => {
    return pet_allowed === 1
      ? schema.required("Number of pets is required when pets are allowed.")
      : schema;
  }),

  price_per_pet: yup.string().when("pet_allowed", (pet_allowed, schema) => {
    return pet_allowed === 1
      ? schema.required("Price per pet is required when pets are allowed.")
      : schema;
  }),

  cleaning_fee: yup.string().nullable().notRequired(),
  cleaning_freq: yup.string().nullable().notRequired(),

  city_fee: yup.string().nullable().notRequired(),
  city_fee_freq: yup.string().nullable().notRequired(),
  tax_percentage: yup.string().nullable().notRequired(),

  custom_period_pricing: yup
    .number()
    .oneOf([0, 1], "Invalid value for custom period pricing")
    .notRequired("This field is required."),

  custom_periods: yup.array().when("custom_period_pricing", {
    is: 1,
    then: () =>
      yup
        .array()
        .of(
          yup.object().shape({
            start_date: yup
              .date()
              .nullable()
              .required("Start date is required."),
            end_date: yup.date().nullable().required("End date is required."),
            nightly_price: yup.string().required("Custom price is required."),
            // weekend_price: yup
            //   .string()
            //   .required("Custom weekly price is required."),
            price_add_guest: yup
              .string()
              .required("Price per additional guest is required."),
          })
        )
        .min(1, "At least one custom period is required."),
    otherwise: () => yup.array().notRequired(),
  }),

  extra_services: yup
    .number()
    .oneOf([0, 1], "Invalid value for extra services")
    .required("This field is required."),
  extra_service: yup.array().when("extra_services", {
    is: 1,
    then: () =>
      yup
        .array()
        .of(
          yup.object().shape({
            name: yup.string().required("Service name is required."),
            price: yup.string().required("Service price is required."),
            type: yup.string().required("Service type is required."),
            quantity: yup.string().required("Quantity is required."),
          })
        )
        .min(1, "At least one extra service is required."),
    otherwise: () => yup.array().notRequired(),
  }),

  features: yup.array().of(
    yup.object().shape({
      id: yup.string().notRequired("Feature is required."),
      sub_features: yup.array().when("id", {
        is: (id) => !!id, // sub_features is required only if id has a truthy value
        then: () =>
          yup
            .array()
            .of(yup.string().required("Sub-feature is required"))
            .min(1, "At least one sub-feature is required"),
        otherwise: () => yup.array().notRequired(),
      }),
    })
  ),

  cancellation_policy_short: yup.string().notRequired(),
  cancellation_policy_long: yup.string().notRequired(),

  min_day_booking: yup.string().nullable().notRequired(),
  max_day_booking: yup.string().nullable().notRequired(),
  check_in_after: yup.string().nullable().notRequired(),
  check_out_before: yup.string().nullable().notRequired(),
  smoking_rules: yup.string().when("smoking_allowed", {
    is: 1,
    then: () => yup.string().required("Smoking rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  pet_rules: yup.string().when("rules_pet_allowed", {
    is: 1,
    then: () => yup.string().required("Pet rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  party_rules: yup.string().when("party_allowed", {
    is: 1,
    then: () => yup.string().required("Party rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  children_rules: yup.string().when("children_allowed", {
    is: 1,
    then: () => yup.string().required("Children rules are required."),
    otherwise: () => yup.string().notRequired(),
  }),

  rules: yup.string().notRequired().nullable(),
  welcome_message: yup.string().notRequired().nullable(),
});
export const addListingDefaultValues = {
  is_draft: 0,
  listing_type: "short-term rental",
  address: "",
  unit_no: "",
  city: "",
  state: "",
  zipcode: "",
  area: "",
  country: "",
  lng: "",
  lat: "",
  images: [],
  type_of_space: "",
  lodging_type: "",
  title: "",
  no_of_guest: "",
  no_of_bedrooms: "",
  no_of_beds: "",
  no_of_bathrooms: "",
  no_of_rooms: "",
  unit_of_measure: "ft",
  size: "",
  description: "",
  bedrooms: [],
  helicopter_allowed: 0,
  airports: [
    {
      airport_identifier: "",
      airport_name: "",
      airport_use: "",
      operation_hours: "",
      lighting: 0,
      ctaf_unicom: "",
      fuel: [],
      surface: [],
      parking: "",
      orientation: "",
      runway_condition: "",
      pattern: "",
      elevation_feets: "",
      elevation_meters: "",
      distance_from_runway: "",
      air_nav: "",
      ground_transportation: "",

      additional_info: "",
      dimension_feetX: "",
      dimension_feetY: "",
      dimension_metersX: "",
      dimension_metersY: "",
    },
  ],
  instant_booking: 0,
  nightly_price: "",
  apply_weekend_price: "",
  weekend_nightly_price: "",
  nightly_price_seven_plus: "",
  nightly_price_thirty_plus: "",

  additional_guest: 0,
  no_of_additional_guest: 0,
  additional_guest_price: "",

  pet_allowed: 0,
  no_of_pets: 0,
  price_per_pet: "",

  cleaning_fee: "",
  city_fee: "",
  cleaning_freq: null,
  city_fee_freq: null,
  tax_percentage: "0",

  custom_period_pricing: 0,
  custom_periods: [
    {
      start_date: null,
      end_date: null,
      nightly_price: "",
      // weekend_price: "",
      price_add_guest: "",
    },
  ],
  extra_services: 0,
  extra_service: [
    {
      name: "",
      price: "",
      type: "",
      quantity: "",
    },
  ],
  features: [
    {
      id: "",
      sub_features: [],
    },
  ],

  cancellation_policy_short: "",
  cancellation_policy_long: "",
  min_day_booking: "",
  max_day_booking: "",
  check_in_after: "",
  check_out_before: "",
  smoking_allowed: 0,
  smoking_rules: "",

  rules_pet_allowed: 0,
  pet_rules: "",

  party_allowed: 0,
  party_rules: "",

  children_allowed: 0,
  children_rules: "",
  children_ages: [5, 15],
  infant_ages: [5, 15],

  rules_instructions: "",
  rules: "",
  welcome_message_instructions: "",
  welcome_message: "",
  blocked_dates: [],
  deleted_images: [],
};

export const GOOGLE_MAP_STYLES = [
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: 36,
      },
      {
        color: "#333333",
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fefefe",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#fefefe",
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        color: "#edebe4",
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#dedede",
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#d1ecc7",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff",
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#f2f2f2",
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#bddddd",
      },
      {
        lightness: 17,
      },
    ],
  },
];
